import { WorkflowActionTypes } from 'src/app/models/RestApiCaller/Enums/workflow-action-types';
import { BaseActionData } from './base-action-data';

/**
 * Représente les données d'une action 'Envoi de mail'.
 */
export class SendMailActionData extends BaseActionData {
    /**
     * id du modèle de mail à utiliser.
     */
    public templateId: number;

    /**
     * valeur indiquant si le mail doit être envoyé automatiquement.
     */
    public autoSend: boolean;

    /**
     * valeur indiquant si le mail ne doit pas être envoyé lorsqu'un destinataire est manquant.
     */
    public dontSendIfRecipientMissing: boolean;

    /**
     * Constructeur.
     */
    constructor() {
        super(WorkflowActionTypes.SendMail);
    }

    /**
     * Retourne une copie d'une instance de SendMailActionData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: SendMailActionData) {
        if (!!other) {
            const instance = new SendMailActionData();
            instance.templateId = other.templateId;
            instance.autoSend = other.autoSend;
            instance.dontSendIfRecipientMissing = other.dontSendIfRecipientMissing;
            instance.type = other.type;

            return instance;
        } else {
            return null;
        }
    }
}
